<!--Sidebar-->
<div
  class="pmd-sidebar-overlay"
  [ngClass]="sidebarOverlay ? 'pmd-sidebar-overlay-active' : ''"
  (click)="leftSidebar.removeGroup(leftSidebar); sidebarOverlay = false"
></div>
<pmd-sidebar
  aria-label="Left Sidebar"
  #leftSidebar
  placement="left"
  position="slidepush"
  class="pmd-sidebar pmd-sidebar-dark pmd-sidebar-slide-push"
  isOpenWidth="1200"
  role="navigation"
  id="leftSidebarMenu"
  [isOpen]="true"
>
  <div class="bg-primary pmd-sidebar-main">
    <div class="sidebar-menu-wrapper">
      <ul class="nav flex-column pmd-sidebar-nav">
        <li class="nav-item" #dashBoardListEl>
          <a class="nav-link" aria-label="Dashbard">
            <span class="flex-grow-1">DASHBOARD</span>
            <button
              type="button"
              pmd-btn-fab
              pmd-btn-flat
              color="light"
              size="xs"
              tabindex="0"
              (click)="showSubmenu(dashBoardListEl)"
            >
              <i class="material-icons pmd-icon-xs arrow">keyboard_arrow_down</i>
            </button>
          </a>
          <div class="sidebar-menu-group">
            <ul class="px-3">
              <li class="nav-item" *ngFor="let menu of mainSidebarMenus; let i = index">
                <a
                  class="nav-link"
                  *ngIf="menu.path"
                  [routerLinkActiveOptions]="{ exact: menu.pathOptions?.exact }"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  [tabindex]="menu.isDisabled ? -1 : 0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                  [routerLink]="menu.path"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
                <a
                  class="nav-link"
                  *ngIf="menu.onClick"
                  (click)="menu.onClick()"
                  (keydown.enter)="menu.onClick()"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  tabindex="0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item" #courseListEl>
          <a class="nav-link" aria-label="COURSE">
            <span class="flex-grow-1">COURSE</span>
            <button
              type="button"
              pmd-btn-fab
              pmd-btn-flat
              color="light"
              size="xs"
              tabindex="0"
              (click)="showSubmenu(courseListEl)"
            >
              <i class="material-icons pmd-icon-xs arrow">keyboard_arrow_down</i>
            </button>
          </a>
          <div class="sidebar-menu-group">
            <ul class="px-3">
              <li class="nav-item" *ngFor="let menu of selectedFirstMenu; let i = index">
                <a
                  class="nav-link"
                  *ngIf="menu.path"
                  [routerLinkActiveOptions]="{ exact: menu.pathOptions?.exact }"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  [tabindex]="menu.isDisabled ? -1 : 0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                  [routerLink]="menu.path"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
                <a
                  class="nav-link"
                  *ngIf="menu.onClick"
                  (click)="menu.onClick()"
                  (keydown.enter)="menu.onClick()"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  tabindex="0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item" #gameListEl>
          <a class="nav-link" aria-label="GAME">
            <span class="flex-grow-1">GAME</span>
            <button
              type="button"
              pmd-btn-fab
              pmd-btn-flat
              color="light"
              size="xs"
              tabindex="0"
              (click)="showSubmenu(gameListEl)"
            >
              <i class="material-icons pmd-icon-xs arrow">keyboard_arrow_down</i>
            </button>
          </a>
          <div class="sidebar-menu-group">
            <ul class="px-3">
              <li class="nav-item" *ngFor="let menu of selectedGameMenu; let i = index">
                <a
                  class="nav-link"
                  *ngIf="menu.path"
                  [routerLinkActiveOptions]="{ exact: menu.pathOptions?.exact }"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  [tabindex]="menu.isDisabled ? -1 : 0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                  [routerLink]="menu.path"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
                <a
                  class="nav-link"
                  *ngIf="menu.onClick"
                  (click)="menu.onClick()"
                  (keydown.enter)="menu.onClick()"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  tabindex="0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item" #helpListEl>
          <a class="nav-link" aria-label="HELP">
            <span class="flex-grow-1">HELP</span>
            <button
              type="button"
              pmd-btn-fab
              pmd-btn-flat
              color="light"
              size="xs"
              tabindex="0"
              (click)="showSubmenu(helpListEl)"
            >
              <i class="material-icons pmd-icon-xs arrow">keyboard_arrow_down</i>
            </button>
          </a>
          <div class="sidebar-menu-group">
            <ul class="px-3">
              <li class="nav-item" *ngFor="let menu of helpSidebarMenu; let i = index">
                <a
                  class="nav-link"
                  *ngIf="menu.path"
                  [routerLinkActiveOptions]="{ exact: menu.pathOptions?.exact }"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  [tabindex]="menu.isDisabled ? -1 : 0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                  [routerLink]="menu.path"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
                <a
                  class="nav-link"
                  *ngIf="menu.onClick"
                  (click)="menu.onClick()"
                  (keydown.enter)="menu.onClick()"
                  [class.disabled]="menu.isDisabled"
                  routerLinkActive="active"
                  tabindex="0"
                  [id]="i == 0 ? 'dashboardLink' : ''"
                  [attr.aria-label]="menu.ariaLabel"
                >
                  <i
                    class="material-symbols-outlined pmd-nav-item-icon pmd-icon-sm"
                    *ngIf="menu.icon && menu.icon"
                    aria-hidden="true"
                    >{{ menu.icon }}</i
                  >
                  <span class="flex-grow-1">{{ menu.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- <ul class="nav flex-column pmd-sidebar-nav bottom-fixed-menu"
			role="menubar">
			<li class="nav-item"
				role="none">
				<a class="nav-link"
					role="menuitem"
					routerLinkActive='active'
					routerLink="/contact"
					aria-label="Press enter to open the the contact page">
					<i class="material-icons pmd-nav-item-icon pmd-icon-sm"
						aria-hidden="true">contact_page</i>
					<span class="flex-grow-1">{{ 'LAYOUT.HOME.CONTACT' | translate }}</span>
				</a>
			</li>
		</ul> -->
  </div>
</pmd-sidebar>

<!-- Simulate Game to Next Period Modal -->
<div
  tabindex="0"
  pmdModal
  modalTrap
  #simulateGameModal="pmd-modal"
  class="modal pmd-modal fade"
  role="dialog"
  aria-labelledby="simulateGameNextPeriodLabel"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body text-center">
        <div
          class="mb-3 pmd-avatar pmd-avatar-secondary pmd-avatar-xl d-inline-flex"
          aria-hidden="true"
        >
          <img
            src="assets/images/probanker-logo-icon.svg"
            height="40"
            class="align-center logo-icon"
            alt="Probanker Logo Icon"
          />
        </div>
        <h3 id="simulateGameNextPeriodLabel" class="h3">Simulate Game to Next Period</h3>
        <p id="simulateGameNextPeriodDescription">
          Are you sure you want to lock this game and queue it for simulation?
        </p>
      </div>
      <div class="modal-footer justify-content-center">
        <button
          tabindex="0"
          aria-label="Close Delete Dialog"
          (click)="simulateGameModal.hide()"
          pmdRipple
          pmd-btn
          type="button"
          class="me-3 btn-outline-dark"
        >
          Cancel
        </button>
        <button
          tabindex="0"
          (click)="simulateGame()"
          aria-describedby="simulateGameNextPeriodDescription"
          pmdRipple
          pmd-btn
          color="primary"
          type="button"
          pmd-btn-raised
        >
          SIMULATE
        </button>
      </div>
    </div>
  </div>
</div>
<!-- End Simulate Game to Next Period Modal -->

<!-- Rollback Period Modal -->
<div
  tabindex="0"
  pmdModal
  modalTrap
  #rollbackGameModal="pmd-modal"
  class="modal pmd-modal fade"
  role="dialog"
  aria-labelledby="rollback"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <form [formGroup]="rollbackForm">
        <div class="modal-header mb-0 align-items-start">
          <div class="pmd-title-separator">
            <h3 class="modal-title mb-1" id="rollback">Rollback Period</h3>
            <p class="mb-0 card-subtitle">Change Rollback Period for game</p>
          </div>
          <button
            tabindex="0"
            type="button"
            class="pmd-icon-with-title p-0"
            aria-label="Press enter to close the add user dialog"
            (click)="rollbackGameModal.hide()"
          >
            <i class="material-icons pmd-icon-rounded pmd-icon-light pmd-icon-xs"> close </i>
            <p class="pmd-icon-title mt-2">Close</p>
          </button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-md-5">
              <p class="pmd-list-subtitle">Current Time Period</p>
              <h6 class="mb-0" role="heading" aria-level="1">{{ game?.period }}</h6>
            </div>
            <div class="col-md-7">
              <pmd-checkbox
                ariaLabel="Press Space Key to Keep you logged in"
                [checked]="f.erase.value"
                [state]="f.erase.value ? 'checked' : 'unchecked'"
                formControlName="erase"
              >
                <h6 role="heading" aria-level="1" class="mb-0">Erase period data</h6>
                <p class="form-help-text mt-0">
                  Period data will {{ f.erase.value ? '' : 'NOT' }} be deleted.
                </p>
              </pmd-checkbox>
            </div>
          </div>
          <pmd-form-group
            [ngClass]="
              sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) && {
                'pmd-textfield-is-valid': !f.period.errors,
                'pmd-textfield-is-invalid': f.period.errors,
              }
            "
          >
            <label class="mb-2" for="user" aria-hidden="true">Period</label>
            <ng-select
              class="pmd-select pmd-select-outline mb-3 mb-lg-0"
              [ngClass]="
                sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) && {
                  'is-valid': !f.period.errors,
                  'is-invalid': f.period.errors,
                }
              "
              [attr.aria-required]="
                sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) &&
                f.period.errors &&
                f.period.errors.required
              "
              [attr.aria-invalid]="
                sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) &&
                f.period.errors &&
                f.period.errors.required
              "
              [items]="simulatedPeriods"
              formControlName="period"
              placeholder="Select user"
              id="timeperiod"
              ariaLabel="Press enter to select one of period from the dropdown list or press tab to skip"
              aria-expanded="false"
            >
              <ng-template ng-label-tmp let-simulatedPeriod="item" let-clear="clear">
                <span class="ng-value-label">{{ simulatedPeriod }}</span>
                <span class="ng-value-icon left material-icons" (click)="clear(simulatedPeriod)"
                  >close</span
                >
              </ng-template>
              <ng-template ng-option-tmp let-simulatedPeriod="item">
                {{ simulatedPeriod }}
              </ng-template>
            </ng-select>
            <p
              class="form-help-text"
              *ngIf="
                !sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) && f.period.errors
              "
              id="timeperiod"
              aria-hidden="true"
            >
              <span class="material-icons me-1">
                <svg _ngcontent-ycx-c153="" width="18" height="18" viewBox="0 0 18 18">
                  <path
                    _ngcontent-ycx-c153=""
                    id="Path_2582"
                    data-name="Path 2582"
                    d="M0,0H18V18H0Z"
                    fill="none"
                  ></path>
                  <path
                    _ngcontent-ycx-c153=""
                    id="Path_2583"
                    data-name="Path 2583"
                    d="M8.75,5.75h1.5v1.5H8.75Zm0,3h1.5v4.5H8.75ZM9.5,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.5,2Zm0,13.5a6,6,0,1,1,6-6A6.008,6.008,0,0,1,9.5,15.5Z"
                    transform="translate(-0.5 -0.5)"
                  ></path>
                </svg>
              </span>
              Please select carefully becasue this process can't be undone.
            </p>
            <div
              *ngIf="
                sharedService.isFieldDirty(f.period, isRollbackSubmitAttempted) && f.period.errors
              "
              role="alert"
              class="invalid-feedback"
              id="simulation-validation"
              [attr.aria-label]="'COURSE.ADD.SIMULATOR_REQ' | translate"
            >
              <span class="material-icons pmd-xs me-2" aria-hidden="true">error_outline</span>
              <span *ngIf="f.period.errors.required"> Please select one period to rollback </span>
            </div>
          </pmd-form-group>
        </div>
        <div class="modal-footer">
          <button
            tabindex="0"
            aria-label="Close Delete Dialog"
            (click)="rollbackGameModal.hide()"
            pmdRipple
            pmd-btn
            type="button"
            class="me-3 btn-outline-dark"
          >
            Cancel
          </button>
          <button
            tabindex="0"
            (click)="rollbackGame()"
            aria-describedby="addUserDescription"
            pmdRipple
            pmd-btn
            color="primary"
            type="button"
            pmd-btn-raised
            [disabled]="!rollbackForm.valid"
            [attr.aria-disabled]="!rollbackForm.valid"
          >
            ROLL BACK
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- End Rollback Period Modal -->
